import { logError } from "@faire/web--source/common/logging";
import {
  isNotNull,
  isNotUndefined,
} from "@faire/web--source/common/typescriptUtils";
import { WebApiRequestCancellationError } from "@faire/web-api--source/WebApiRequestCancellationError";

/**
 * Logs an error if it is not a WebApiRequestCancellationError.
 */
export const logErrorIfNotWebApiRequestCancellation = (
  error: unknown
): void => {
  if (
    isNotUndefined(error) &&
    isNotNull(error) &&
    !(error instanceof WebApiRequestCancellationError)
  ) {
    logError(error);
  }
};
